module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point03_02_spectacular_spot-2e4cb66774c6f0e3e288b9b6ab02d057.jpg";